import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GpsFixedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gps_fixed"}/>
}
